import { PRIVATE_STATION_CHARGING_SUMMARY } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  privateStationChargingSummaries: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const privateStationChargingSummaryReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case PRIVATE_STATION_CHARGING_SUMMARY.REQUEST: {
      return { ...state, isLoading: true };
    }
    case PRIVATE_STATION_CHARGING_SUMMARY.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        privateStationChargingSummaries: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case PRIVATE_STATION_CHARGING_SUMMARY.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default privateStationChargingSummaryReducer;
